import store from 'store'

export const getItems = (): Maybe<CartItems> => {
  return store.get('cartItems')
}

export const updateCart = (items: CartItems): void => {
  store.set('cartItems', items)
}
